export default "__VITE_ASSET__LlO04PNL__"